export default __webpack_public_path__ + "static/media/guide-legal-background.57df129c.png";